import styled, { keyframes } from "styled-components";
import { colors } from "../../../../styles/colors";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const CardContainer = styled.div<{
  $useBackground: boolean;
  $animationDelay?: number;
}>`
  background: ${({ $useBackground }) =>
    $useBackground ? colors.lightBlueGrayBackground : colors.white};
  border-radius: 9px;
  border: ${({ $useBackground }) =>
    $useBackground ? "none" : `0.5px solid ${colors.lightBlueGray}`};
  padding: 10px 20px 12px 12px;
  position: relative;
  opacity: 0;
  animation: ${fadeInUp} 0.6s ease-out forwards;
  animation-delay: ${({ $animationDelay = 0 }) => $animationDelay}ms;
`;

export const ChartLoadingContainer = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${colors.lightGray};
  border-radius: 6px;
  margin-top: 8px;
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${colors.lightBlueGray};
  border-top: 2px solid ${colors.blue};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingText = styled.span`
  font-size: 12px;
  color: ${colors.darkBlue};
  font-weight: 500;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
